import axios from 'axios';
import { getToken, clearSession } from '../auth/session';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8082/api/v1',
  // baseURL: 'http://localhost:8082/api/v1',
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Only tell other tabs to log out if this tab really had a session (its token expired or
      // was rejected) — not for a 401 from a logged-out tab.
      clearSession({ broadcast: !!getToken() });
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
